<template>
    <div class="sidebar-box">
        <el-menu :default-active="defaultSel" v-if="navType == 1">
            <el-menu-item v-for="(item, index) in shopMg" :key="index" :index="item.index" @click="openUrl(item)">
                <i class="el-icon-menu"></i>
                <span slot="title">{{item.name}}</span>
            </el-menu-item>
        </el-menu>
        <el-menu :default-active="defaultSel" v-if="navType == 2">
            <el-menu-item v-for="(item, index) in glyMg" :key="index" :index="item.index" @click="openUrl(item)">
                <i class="el-icon-menu"></i>
                <span slot="title">{{item.name}}</span>
            </el-menu-item>
        </el-menu>
        <el-menu :default-active="defaultSel" v-if="navType == 3">
            <el-menu-item v-for="(item, index) in nrMg" :key="index" :index="item.index" @click="openUrl(item)">
                <i class="el-icon-menu"></i>
                <span slot="title">{{item.name}}</span>
            </el-menu-item>
        </el-menu>
        <el-menu :default-active="defaultSel" v-if="navType == 4">
            <el-menu-item v-for="(item, index) in skYx" :key="index" :index="item.index" @click="openUrl(item)">
                <i class="el-icon-menu"></i>
                <span slot="title">{{item.name}}</span>
            </el-menu-item>
        </el-menu>
    </div>
</template>

<script>
import { shopMg, glyMg, nrMg, skYx } from './config.js'
export default {
    props: {
        defaultSel: {
            type: String,
            default: '1'
        },
        navType: {
            type: [String, Number],
            default: 1
        }
    },
    data () {
        return {
            shopMg: shopMg,
            glyMg: glyMg,
            nrMg: nrMg,
            skYx: skYx
        }
    },
    methods: {
        openUrl(e){
            this.$router.push({path: e.url});
        }
    }
}
</script>

<style>
.sidebar-col-tit{
    font-size: 14px;
    padding-left: 16px;
    height: 60px;
    line-height: 60px;
    color: #78858E;
    font-weight: 700;
}
</style>




// WEBPACK FOOTER //
// src/components/sidebar.vue